import defaultSettings from '@/settings'
import localCache from '@/utils/cache'
import { SettingState } from './types'

const { sideTheme, showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle } = defaultSettings

const storageSetting = localCache.getCache('layout-setting') || {}

const state: SettingState = {
  title: '',
  theme: storageSetting.theme || '#409EFF',
  sideTheme: storageSetting.sideTheme || sideTheme,
  showSettings: showSettings,
  topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
  tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
  fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
  sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
  dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle
}

const mutations = {
  CHANGE_SETTING: (state: SettingState, { key, value }: { key: string, value: any }) => {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      (state as any)[key] = value
      
      // 将变更保存到缓存
      const setting = localCache.getCache('layout-setting') || {}
      setting[key] = value
      localCache.setCache('layout-setting', setting)
    }
  }
}

// 定义commit函数类型
type CommitFn = (type: string, payload?: any) => void;

const actions = {
  // 修改布局设置
  changeSetting({ commit }: { commit: CommitFn }, data: { key: string, value: any }) {
    commit('CHANGE_SETTING', data)
  },
  // 设置网页标题
  setTitle(_: { commit: CommitFn }, title: string) {
    state.title = title
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}